interface GetCancellationCheckInDateParams {
  checkInDate?: string
  hasUserSelectedDates: boolean
  isCharterBundleOffer: boolean
  isMaldivesDirectBundle: boolean
}

export function getCancellationCheckInDate({
  checkInDate,
  hasUserSelectedDates,
  isCharterBundleOffer,
  isMaldivesDirectBundle,
}: GetCancellationCheckInDateParams): string | undefined {
  if (isCharterBundleOffer && isMaldivesDirectBundle && !hasUserSelectedDates) {
    return undefined
  }

  return checkInDate
}
